import React, { useEffect, useState } from "react";
import GiveFeedbackModalPresenter from "./GiveFeedbackModalPresenter";
import DTOGiveFeedbackModal from "./DTOGiveFeedbackModal";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const GiveFeedbackModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  return (
    <div>
      <DTOGiveFeedbackModal />

      <GiveFeedbackModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={trans}
      />
    </div>
  );
};

export default GiveFeedbackModalController;
